import {
  DEFAULT_BULK_DATA,
  DEFAULT_APP_BULK_PROCESS_DATA,
  DEAFUALT_APP_BULK_PROCESS_STATUS,
} from "../constants/bulkProcessConstant";

const initialState = {
  bulkProcessData: DEFAULT_APP_BULK_PROCESS_DATA,
  bulkProcessStatus: DEAFUALT_APP_BULK_PROCESS_STATUS,
  bulkUploadData: DEFAULT_BULK_DATA,
};

const bulkProcessReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESTORE_REDUX_STATE":
      return {
        ...initialState,
      };

    case "RESET_BULK_UPLOAD_DATA":
      return {
        ...state,
        bulkUploadData: JSON.parse(JSON.stringify(DEFAULT_BULK_DATA)),
      };

    case "UPDATE_BULK_LOADER":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          uploading: action.payload,
        },
      };

    case "UPDATE_BULK_PAYMENT":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          showBulkPayment: action.payload,
        },
      };

    case "UPDATE_SKIP_FILE_CHECK":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          skipFileCheck: action.payload,
        },
      };

    case "UPDATE_BULK_SCREEN_ERROR":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          uploadFileErr: action.payload,
        },
      };

    case "UPDATE_BULK_PROCESSING":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          processing: action.payload,
        },
      };

    case "UPDATE_BULK_SCREEN":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          activeScreen: action.payload,
        },
      };

    case "UPDATE_CXML_DATA":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          cxmlData: action.payload,
        },
      };

    case "UPDATE_BULK_FILE_NAME":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          fileName: action.payload,
        },
      };

    case "UPDATE_BULK_SCREEN_MSG":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          uploadFileMsg: action.payload,
        },
      };

    case "UPDATE_BULK_FILE_BATCHID":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          batchId: action.payload,
        },
      };

    case "UPDATE_BULK_UPLOAD_DATA":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          ...JSON.parse(JSON.stringify(action.payload)),
        },
      };

    case "UPDATE_BULK_FILE_PROCESS_DATA":
      return {
        ...state,
        bulkUploadData: {
          ...state.bulkUploadData,
          ...JSON.parse(JSON.stringify(action.payload)),
        },
      };

    case "UPDATE_BULK_PROCESS_DATA":
      return {
        ...state,
        bulkProcessData: action.payload.bulkProcessData,
      };

    case "UPDATE_BULK_PROCESS_STATUS":
      return {
        ...state,
        bulkProcessStatus: action.payload.bulkProcessStatus,
      };

    default:
      return state;
  }
};

export default bulkProcessReducer;
